function splitEmail(str) {
  return str.split(/((?:(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*)|(?:".+"))@(?:(?:\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(?:(?:[a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))/g)
}

function splitQuery(str, query) {
  const ret = []
  if (!query.length) return ret;
  let last = 0;
  while (last < str.length) {
    const index = str.indexOf(query, last);
    if (index === -1) return ret
    last = index + query.length
    ret.push({
      start: index,
      stop: last,
    })
  }
  return ret
}

export default function _g(text, query) {
  const _splitQuery = splitQuery(text, query);
  //console.info('EmailMessageRoomComponents | this.$props.query = ', query, ' | _splitQuery = ', _splitQuery)

  const _splitEmail = splitEmail(text)
  //console.info('EmailMessageRoomComponents | _splitEmail = ', _splitEmail)


  let elements = []
  let position = 0
  let lastSearch = 0

  for (let index = 0; index < _splitEmail.length; index++) {
    const emailIsFind = (index % 2)
    const elOriginal = _splitEmail[index]

    let elEdit = _splitEmail[index]

    if (_splitQuery[lastSearch]) {
      let elNew = [];
      while (true) {
        if (!_splitQuery[lastSearch]) break

        const {start, stop} = _splitQuery[lastSearch]

        if (start >= position + elEdit.length) break

        if (position + elEdit.length >= stop) {
          if (start <= position) {
            elNew.push(
              {
                tag: 'strong',
                text: elEdit.substr(0, (stop - position))
              },
            )
          } else {
            elNew.push(
              elEdit.substr(0, start - position),
              {
                tag: 'strong',
                text: elEdit.substr(start - position, (stop - start))
              },
            )
          }
          elEdit = elEdit.substr(stop - position)
          position = stop
          lastSearch += 1;
          continue
        }

        if (stop > position + elEdit.length) {
          if (start - position > 0) {
            elNew.push(
              elEdit.substr(0, start - position),
            )
          }
          elNew.push(
            {
              tag: 'strong',
              text: elEdit.substr(start - position, elEdit.length)
            },
          )
          position += elEdit.length
          elEdit = ''
          break
        }
      }
      if (elNew.length) {
        if (elEdit.length) {
          position += elEdit.length
          elNew.push(elEdit)
        }
        elEdit = elNew
      }
    }

    if (emailIsFind) {
      elements.push({
        tag: 'a',
        email: elOriginal,
        text: elEdit
      })
    } else {
      elements.push(elEdit)
    }

    if (typeof elEdit === 'string') {
      position += elEdit.length
    }
  }
  //console.info('EmailMessageRoomComponents | elements = ', JSON.stringify(elements))

  return elements
}

/*_g(
  'hi volkoffskij+20211007@gmail.com hi2   hi volkoffskij+20211008@gmail.com hi2',
  'hi2'
)*/
